import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { ReportTemplateTypeEnum } from '../enums/report-template-type.enum';

/**
 * Report template DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.REPORT_TEMPLATE)
export class ReportTemplateSearchDto extends BaseSearchDto {
	name!: string;
	description?: string;
	type!: ReportTemplateTypeEnum;
	tags?: TagListDto[];

	displayValue(): string {
		return `${this.name}`;
	}

	shortDisplayValue(): string | null {
		return null;
	}

	periodDisplayValue(): string | null {
		return null;
	}

	extraDisplayValue(): string | null {
		return null;
	}

	pillDisplayValue(): string {
		return '';
	}
}
